import React from "react";
import { ReactComponent as Light } from "../../../assets/new-icons/light.svg";
import { ReactComponent as Gas } from "../../../assets/new-icons/gas.svg";
import { useEffect } from "react";
import DownloadIcon from "@mui/icons-material/Download";
import { useSelector } from "react-redux";
import PriceBoxRicaricabile from "../PriceBox/PriceBoxRicaricabile";
import PriceBoxRelax from "../PriceBox/PriceBoxRelax";
import PriceBoxTradizionale from "../PriceBox/PriceBoxTradizionale";
import PriceBoxGas from "../PriceBox/PriceBoxGas";
import { DateTime } from 'luxon';
import { useFetchLoginGas } from '../../../functions/loginGas';

function DetailPod(props) {
  const {
    podStart,
    podStartDate,
    revoCode,
    customerCode,
    customerId,
    podCode,
    ownerAddress,
    ownerCity,
    podOwner,
    podOwnerGas,
    taxCodeGas,
    taxCode,
  } = props.state;
  const idGroup = useSelector((user) => user.user.idGruppo);
  const fetchLogin = useFetchLoginGas()

  useEffect(() => {
    window.scrollTo(0, 0);
    if(isGasForniture(customerId)){
      fetchLogin(customerCode)
    }
  }, []);
  function isGasForniture(pod) {
    return pod > 200000;
  }

  return (
    <>
      <div className="text">
        <div className="rowCustom">
          <div className="icon">
            {isGasForniture(customerId) ? <Gas /> : <Light />}
          </div>
          <p className="main">{podCode}</p>
        </div>

        <p className="secondary address">{ownerAddress.toLowerCase()}</p>
        <p className="secondary city">{ownerCity}</p>
      </div>
      <div className="body">
        {isGasForniture(customerId) ? (
          <PriceBoxGas />
        ) : idGroup === 1 ? (
          <PriceBoxRicaricabile />
        ) : idGroup === 2 ? (
          <PriceBoxRelax />
        ) : (
          <PriceBoxTradizionale />
        )}

        <div className="info">
          <div className="item">
            <p className="main">Intestatario contratto</p>
            <p className="secondary">
              {isGasForniture(customerId) ? podOwnerGas : podOwner}
            </p>
          </div>
          <div className="item">
            <p className="main">C.F.</p>
            <p className="secondary">
              {isGasForniture(customerId) ? taxCodeGas : taxCode}
            </p>
          </div>
          <div className="item">
            <p className="main">Codice POD</p>
            <p className="secondary">{podCode}</p>
          </div>
          <div className="customRow">
            <div className="item">
              <p className="main">Codice Cliente</p>
              <p className="secondary">{customerCode}</p>
            </div>
            {revoCode && (
              <div className="item">
                <p className="main">Codice Revoluzionario</p>
                <p className="secondary">{podCode}</p>
              </div>
            )}
          </div>
          <div className="customRow">
            <div className="item">
              <p className="main">Data firma</p>
              <p className="secondary">
                  {DateTime.fromISO(podStart, { locale: "it" }).toFormat(
                  `DD`
                )}
                </p>
            </div>
            <div className="item">
              <p className="main">Data attivazione</p>
              <p className="secondary">
                {DateTime.fromISO(podStartDate, { locale: "it" }).toFormat(
                  `DD`
                )}
              </p>
            </div>
          </div>
          <div className="contractButton">
            <button
              onClick={() =>
                isGasForniture(customerId)
                  ? window.open(
                      `https://my.revoluce.it/uploads/contratti_gas/RDF_Revoluce_${customerCode}.pdf`,
                      "_blank"
                    )
                  : window.open(
                      `https://my.revoluce.it/myrevoluce/uploads/contratti_2/RDF_Revoluce_${customerCode}.pdf`,
                      "_blank"
                    )
              }
            >
              Scarica contratto <DownloadIcon />
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default DetailPod;
